const privateOptions = [
  {
    screenName: 'Root',
    pathname: '/',
    exact: true,
  },
  {
    screenName: 'LinkShortner',
    pathname: '/link-shortner',
    exact: true,
  },
  {
    screenName: 'LinkGenerator',
    pathname: '/link-generator',
    exact: true,
  },
  {
    screenName: 'Home',
    pathname: '/home',
    exact: true,
  },
  {
    screenName: 'ModalRedirect',
    pathname: '/modal-redirect',
    exact: true,
  },
  {
    screenName: 'ModalManagement',
    pathname: '/modal-management',
    exact: true,
  },
  {
    screenName: 'ListLives',
    pathname: '/lives',
    exact: true,
  },
  {
    screenName: 'ListPrograms',
    pathname: '/programs',
    exact: true,
  },
  {
    screenName: 'DetailsProgram',
    pathname: '/details-program/:id',
    exact: true,
  },
  {
    screenName: 'RegisterNewLive',
    pathname: '/lives/register',
    exact: true,
  },
  {
    screenName: 'RegisterNewLive',
    pathname: '/lives/register/:id',
    exact: true,
  },
  {
    screenName: 'CreateBanner',
    pathname: '/create-banner/:type',
    exact: true,
  },
  {
    screenName: 'CreateBanner',
    pathname: '/edit-banner/:type/:id',
    exact: true,
  },
  {
    screenName: 'ListBanners',
    pathname: '/list-banners',
  },
  {
    screenName: 'PublishBanner',
    pathname: '/publish-banner/:id',
    exact: true,
  },
  {
    screenName: 'StructureBonus',
    pathname: '/structureBonus',
    exact: true,
  },
  {
    screenName: 'CreateEditProgram',
    pathname: '/create-edit-program/:idProgram?',
    exact: true,
  },
  {
    screenName: 'PushNotifications',
    pathname: '/push-notifications',
    exact: true,
  },
  {
    screenName: 'PushMessage',
    pathname: '/push-message/:idMessage?',
    exact: true,
  },
  {
    screenName: 'Partnership',
    pathname: '/partnership',
    exact: true,
  },
  {
    screenName: 'CreatePartner',
    pathname: '/create-edit-partner/:idPartner?/:visualize?',
  },
  {
    screenName: 'Transactions',
    pathname: '/transactions',
    exact: true,
  },
  {
    screenName: 'TransactionInfo',
    pathname: '/transactions/:idTransaction',
    exact: true,
  },
  {
    screenName: 'ListCaptions',
    pathname: '/captions/',
    exact: true,
  },
  {
    screenName: 'CreateCaptions',
    pathname: '/captions/create/:idContent?/:language?',
    exact: true,
  },
  {
    screenName: 'ListCaptionsByProgram',
    pathname: '/captions/:nameProgram/:idProgram',
    exact: true,
  },
];

export default privateOptions;
